import React, { useCallback, useEffect, useMemo, useState } from 'react';
import { observer } from 'mobx-react';
import { Block, FlexDiv, ProgressWithNumber, SearchInput } from '@awarego-ui/components';
import TableServer from '../../../../components/table/TableServer';
import { useStores } from '../../../../hooks/use-stores';

function TrainingThreatAreas({ companyId, training }) {
    const { automationStore } = useStores();
    const [query, setQuery] = useState({
        p: 0,
        n: 10,
        order: 'name asc',
        filter: '',
    });

    useEffect(() => {
        automationStore.loadThreatAreas(companyId, training.id, query);
    }, [automationStore, companyId, training.id, query]);

    const onChangePagingParams = useCallback((p, n) => {
        setQuery((current) =>
            current.p === p && current.n === n ? current : { ...current, p, n }
        );
    }, []);

    const onChangeSort = useCallback((sortBy) => {
        if (!sortBy || sortBy.length === 0) return;
        const order = `${sortBy[0].id} ${sortBy[0].desc ? 'desc' : 'asc'}`;
        setQuery((current) =>
            current.order === order ? current : { ...current, order }
        );
    }, []);

    const columns = useMemo(
        () => [
            {
                Header: 'Threat area',
                accessor: 'name',
            },
            {
                Header: 'Scenarios',
                accessor: 'scenarios',
            },
            {
                Header: 'Completion rate',
                accessor: 'score',
                Cell: (x) => (
                    <ProgressWithNumber
                        value={
                            x.row.original.total
                                ? Math.round(
                                      (100 * x.value) / x.row.original.total
                                  )
                                : 0
                        }
                        width={150}
                        height={6}
                    />
                ),
            },
        ],
        []
    );

    return (
        <Block gap={24} tablePadding noBorder resetMargin>
            <FlexDiv flexGrow={1} justifyEnd my={10}>
                <SearchInput
                    label=""
                    placeholder="Search"
                    searchValue={query.filter}
                    onChange={(e) => {
                        const filter = e.target.value || '';
                        setQuery((current) =>
                            current.filter === filter && current.p === 0
                                ? current
                                : { ...current, p: 0, filter }
                        );
                    }}
                    onClear={() =>
                        setQuery((current) =>
                            current.filter === '' && current.p === 0
                                ? current
                                : { ...current, p: 0, filter: '' }
                        )
                    }
                />
            </FlexDiv>
            <TableServer
                columns={columns}
                data={automationStore.threatAreas}
                rowsTotal={automationStore.threatAreasTotal}
                pagesTotal={Math.ceil(automationStore.threatAreasTotal / query.n)}
                initialPageSize={query.n}
                defaultSortBy="name"
                defaultSortDescent={false}
                hidePagination={automationStore.threatAreasTotal <= query.n}
                onChangePagingParams={onChangePagingParams}
                onChangeSort={onChangeSort}
                loadingData={automationStore.loadingThreatAreas}
                manualInitialPageTrigger={query.filter}
            />
        </Block>
    );
}

export default observer(TrainingThreatAreas);
